"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = Select;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useFormInputFetch = _interopRequireDefault(require("../shared/stateFunctions/useFormInputFetch"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function Select(props) {
  var label = props.label,
      _props$initialValue = props.initialValue,
      initialValue = _props$initialValue === void 0 ? "" : _props$initialValue,
      cbSuccess = props.cbSuccess;
  var input = (0, _useFormInputFetch.default)(initialValue, props.uid, props.name, props);

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      optionObj = _useState2[0],
      setOptionObj = _useState2[1];

  var options = props.options || [];
  (0, _react.useEffect)(function () {
    var tmpOptionObj = {};
    var options = props.options || [];
    options.map(function (option) {
      tmpOptionObj[option.value] = option.label;
    });
    setOptionObj(tmpOptionObj);
  }, []);

  var inputField = _react.default.createElement("select", _extends({
    class: "custom-select"
  }, input), _react.default.createElement("option", {
    value: ""
  }, "Select..."), options.map(function (option) {
    return _react.default.createElement("option", {
      selected: input.value === option.value,
      value: option.value
    }, option.label);
  }));

  var actionButtons = _react.default.createElement("div", null, _react.default.createElement("button", {
    class: "btn btn-outline-primary",
    type: "button",
    onClick: function onClick() {
      return input.save(cbSuccess);
    }
  }, "Save"), _react.default.createElement("button", {
    class: "btn btn-outline-secondary ml-2",
    type: "button",
    onClick: input.cancelEdit
  }, "Cancel"));

  var linkAction = _react.default.createElement("a", {
    href: "#",
    tabindex: "0",
    onClick: function onClick(e) {
      e.preventDefault();
      input.openEditMode();
    }
  }, getValue());

  var helperText = _react.default.createElement("small", {
    style: {
      color: "gray"
    }
  }, props.helperText);

  function getAction() {
    if (input.isEdit) {
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        class: "form-row"
      }, _react.default.createElement("div", {
        class: "col-8"
      }, inputField), _react.default.createElement("div", {
        class: "col-auto"
      }, actionButtons)), helperText);
    } else {
      return linkAction;
    }
  }

  function getValue() {
    if (input.value === "") {
      return _react.default.createElement("span", {
        style: {
          color: "red"
        }
      }, _react.default.createElement("u", null, "Select..."));
    }

    return optionObj[input.value] || input.value;
  }

  if (props.isCol) {
    return _react.default.createElement("div", null, _react.default.createElement("label", null, label), input.isEdit ? [_react.default.createElement("div", null, inputField), _react.default.createElement("div", null, helperText), _react.default.createElement("div", {
      className: "mt-2"
    }, actionButtons)] : _react.default.createElement("div", null, linkAction));
  }

  return _react.default.createElement("div", {
    className: "row m-0"
  }, _react.default.createElement("div", {
    className: "col-3"
  }, label), _react.default.createElement("div", {
    className: "col-9"
  }, getAction()));
}

var _default = Select;
exports.default = _default;